import { defineComponent as i, createElementBlock as c, openBlock as o, createElementVNode as t, createBlock as s, unref as a, toDisplayString as d, createCommentVNode as m, createVNode as b } from "vue";
import { ScalarColorModeToggle as p } from "@scalar/components";
import { ScalarIconX as u, ScalarIconList as h, ScalarIconMagnifyingGlass as S } from "@scalar/icons";
const g = { class: "t-doc__header mobile-header" }, k = { class: "mobile-header-breadcrumbs" }, _ = { class: "mobile-header-actions" }, C = /* @__PURE__ */ i({
  __name: "DocumentMobileHeader",
  props: {
    label: {},
    showSideBar: { type: Boolean }
  },
  emits: ["showSearch", "toggleSidebar"],
  setup(f, { emit: l }) {
    const n = l;
    return (r, e) => (o(), c("div", g, [
      t("button", {
        class: "icon-button",
        type: "button",
        onClick: e[0] || (e[0] = () => n("toggleSidebar"))
      }, [
        r.showSideBar ? (o(), s(a(u), { key: 0 })) : (o(), s(a(h), { key: 1 }))
      ]),
      t("span", k, d(r.label), 1),
      t("div", _, [
        t("button", {
          class: "icon-button",
          type: "button",
          onClick: e[1] || (e[1] = () => n("showSearch"))
        }, [
          b(a(S))
        ]),
        r.showSideBar ? m("", !0) : (o(), s(a(p), {
          key: 0,
          class: "mobile-header-darkmode-toggle"
        }))
      ])
    ]));
  }
});
export {
  C as default
};
